import { render, staticRenderFns } from "./HubProgramDetail.vue?vue&type=template&id=489c4294&scoped=true&"
import script from "./HubProgramDetail.vue?vue&type=script&lang=js&"
export * from "./HubProgramDetail.vue?vue&type=script&lang=js&"
import style0 from "./HubProgramDetail.vue?vue&type=style&index=0&id=489c4294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c4294",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
